import { Pipe, PipeTransform } from '@angular/core';
import { interval, map, startWith } from 'rxjs';

@Pipe({
    name: 'timeAgo',
    pure: false,
})
export class TimeAgoPipe implements PipeTransform {
    transform(date: Date) {
        return interval(1000).pipe(
            startWith(0),
            map(() => this.getTimeAgo(date)),
        );
    }

    private getTimeAgo(date: Date): string {
        const now = new Date();
        const diffMs = now.getTime() - new Date(date).getTime();
        const diffSeconds = Math.floor(diffMs / 1000);
        const minutes = Math.floor(diffSeconds / 60);

        if (diffSeconds <= 60) {
            return '1 minute ago';
        }

        return `${minutes + 1} minutes ago`;
    }
}
